import { db, storage } from "../lib/firebaseApp"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

/**
 * Callback that expose error object from a function
 * @callback error_up_callback
 * @param {Object} error
 * @param {string} error.code - ['storage/unauthorized', 'storage/canceled', 'storage/unknown']
 * @param {string} error.message
 * @param {string} error.detail
 */

/**
 * Callback for tracking upload status
 * @callback upload_callback
 * @param {string} upload_state - [paused, running] 
 * @param {number} bytesTransferred
 * @param {number} totalBytes
 */



//FIXME - DA COMPLETARE!!!!!!!!!!!!!!!!



/**
 *  Upload file to firebase storage and create a FileReference inside db
 * 
 * @param {Blob | Uint8Array | ArrayBuffer} file - data byte to upload
 * @param {string} storage_path - path inside storage default bucket
 * @param {upload_callback} cb_upload - callback for upload progress
 * @param {callback} cb_upload_completed - callback at upload completed
 * @param {error_up_callback} cb_error - callback for error.  
 * @param {string} contentType - default is "image/jpeg".           
 * @return {string} download url
 */
export const upload_file = ( file, storage_path, contentType='image/jpeg', cb_upload, cb_upload_completed, cb_error,) => {

    // Create the file metadata
    /** @type {any} */
    const metadata = {
        contentType: contentType
    };


    // Upload file and metadata to the object  ex: 'images/mountains.jpg'
    const storageRef = ref(storage, storage_path);
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on('state_changed',
        (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            /* DEBUG: 
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
                case 'paused':
                    console.log('Upload is paused');
                    break;
                case 'running':
                    console.log('Upload is running');
                    break;
            }
            */
            cb_upload( snapshot.state, snapshot.bytesTransferred, snapshot.totalBytes)
        },

        (error) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            cb_error(error);
            /*DEBUG: 
            switch (error.code) {
                case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break;
                case 'storage/canceled':
                    // User canceled the upload
                    break;

                // ...

                case 'storage/unknown':
                    // Unknown error occurred, inspect error.serverResponse
                    break;
            }*/
        },

        async () => {
            // Upload completed successfully, now we can get the download URL
            const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                cb_upload_completed(downloadURL)
            });
        }
    );

}